export default {
  toasts: {
    success: 'Carte cadeau utilisée avec succès.',
    error: "Échec de l'utilisation de la carte cadeau.",
  },
  title: 'Utiliser une carte cadeau',
  subtitle: 'Saisissez le code de la carte cadeau et le montant à déduire de la note du client.',
  form: {
    amount: {
      label: 'Montant à déduire',
    },
    code: {
      label: 'Code de la carte cadeau',
    },
  },
  buttons: {
    redeem: 'Utiliser',
    cancel: 'Annuler',
  },
};
